<template>
  <div class="page-container">
    <img class="w-24 h-24 mt-6 ml-2" src="@/assets/img/logo.svg" />
    <div v-if="isLoading" class="container center">
      <div class="flex flex-col items-center">
        <img class="h-36 mb-14 mt-20" src="@/assets/img/loading.svg" />
      </div>
    </div>
    <div v-if="isCompleted && !isLoading" class="pt-10">
      <div v-if="message"><alert :message="message"></alert></div>
      <div v-if="isSuccess" class="flex flex-col px-6 mt-10">
        <h1>{{ `${webDonationModel.firstname} ${webDonationModel.lastname}` }}</h1>
        <h2 class="mt-4">{{ `Thank you for your donation of $${webDonationModel.amount}` }}</h2>
        <div class="mt-4">
          Please check your email for confirmation. If you don’t receive an email, please note that due to the high
          volume of donations we’ve received, it may take longer than normal for us to process your payment receipt.
        </div>
        <div class="mt-4">For urgent questions, please call our supporter relations team on 1800 032 551</div>
      </div>
    </div>
    <div v-if="!isCompleted && !isLoading" class="container center">
      <div v-if="isValidToken">
        <div class="border-2 border-gray-400 bg-green-50 p-3">
          <div class="flex flex-row">
            <span class="font-bold flex-1">Donor</span>
            <span class="flex-1">{{ `${webDonationModel.firstname} ${webDonationModel.lastname}` }}</span>
          </div>
          <div class="flex flex-row">
            <span class="font-bold flex-1">Appeal name</span>
            <span class="flex-1">{{ webDonationModel.productname }}</span>
          </div>
          <div class="flex flex-row">
            <span class="font-bold flex-1">Donation type</span>
            <span class="flex-1">{{
              webDonationModel.type === 'Single' ? 'One time payment' : 'Regular payment'
            }}</span>
          </div>
          <div class="flex flex-row">
            <span class="font-bold flex-1">Donation amount</span>
            <span class="flex-1">{{ webDonationModel.amount | money }}</span>
          </div>
        </div>
        <div class="mb-5 mt-5 flex flex-row items-center">
          <img class="w-12" src="@/assets/img/secure-icon.svg" />
          <div class="flex flex-col ml-2 uppercase">
            <div class="font-bold">Secure</div>
            <div>Payment</div>
          </div>
        </div>
        <bambora-credit-card-form
          :key="bamboraFormKey"
          @startProcessingPayment="isLoading = true"
          @finishProcessingPayment="isLoading = false"
          @success="processPayment"
          @error="onError"
        ></bambora-credit-card-form>
        <div class="mt-10" v-if="message"><alert :message="message"></alert></div>
      </div>
    </div>
  </div>
</template>

<script>
import BamboraCreditCardForm from '@/components/DonationModal/BamboraCreditCardForm';
import Alert from '@/components/Alert.vue';

export default {
  name: 'SmsPayment',
  components: {
    BamboraCreditCardForm,
    Alert,
  },
  data() {
    return {
      bamboraFormKey: 0,
      isCompleted: false,
      isSuccess: false,
      isValidToken: false,
      isLoading: true,
      token: null,
      message: null,
      webDonationModel: null,
    };
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.token = this.$route.query.token;
      if (this.token) {
        this.webDonationModel = await this.$store.dispatch('smsPayment/isValidToken', this.token);
        this.isValidToken = !!this.webDonationModel;
        this.bamboraFormKey++;
        this.isCompleted = !this.isValidToken;
        if (!this.isValidToken) {
          this.message = {
            content: 'Invalid payment token',
            type: 'error',
          };
        }
      } else {
        this.isCompleted = true;
        this.isValidToken = false;
        this.message = {
          content: 'Invalid payment token',
          type: 'error',
        };
      }
    } catch (err) {
      console.error(err);
      this.message = {
        content: 'Payment server is unable to process transaction. Please try again later.',
        type: 'error',
      };
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    onError() {
      this.message = {
        content: 'The credit card information is not correct. Try another card.',
        type: 'error',
      };
      this.bamboraFormKey += 1;
    },
    async processPayment(responseData) {
      try {
        this.isLoading = true;
        const payload = {
          token: this.token,
          creditCardToken: responseData.token,
          creditCardHolderName: responseData.cardHolderName,
        };
        const transaction = await this.$store.dispatch('smsPayment/processPayment', payload);
        if (transaction.status === 'completed') {
          this.isCompleted = true;
          this.isSuccess = true;
          this.message = {
            content: 'Payment accepted successfully',
            type: 'success',
          };
        } else {
          this.message = {
            content: 'The credit card information is not correct. Try another card.',
            type: 'error',
          };
          this.bamboraFormKey += 1;
        }
      } catch (err) {
        console.error(err);
        this.message = {
          content: 'Payment server is unable to process transaction. Please try again later.',
          type: 'error',
        };
        this.bamboraFormKey += 1;
      } finally {
        this.isLoading = false;
      }
    },
  },
  filters: {
    money: function (value) {
      return Number(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'AUD',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @apply grid grid-cols-1 grid-rows-1 gap-4;
}
</style>
